import { useStore } from '@/store'
import dayjs from 'dayjs'
import ContentGuide from 'global/guides/ContentGuide/ContentGuide'
import Dialog from 'global/guides/Dialog'
import { Navigate, useParams } from 'react-router-dom'
import { centroCusto } from 'service/api'
import { columns } from '../../constats/columns'

export default function FuncionariosCentroCusto() {
    const { centroCustoId } = useParams()
    const empresa = useStore(state => state.company)
    const { data, isLoading } = centroCusto.useFetchById(centroCustoId!, {
        enabled: !!centroCustoId,
    })
    const { FuncionarioCentroCusto = [] } = data ?? {}

    if (!centroCustoId)
        return <Navigate to="/cadastros/centros-custo" replace />

    const rows = FuncionarioCentroCusto.map((item: any) => ({
        matricula: item.Funcionario.matricula,
        nome: item.Funcionario.nome,
        cpf: item.Funcionario.cpf,
        pis: item.Funcionario.pis,
        dtInicial: dayjs.utc(item.dtInicial).format('L'),
        dtFinal: item.dtFinal,
        isAtivo:
            !item.dtFinal || dayjs.utc(item.dtFinal).isAfter(dayjs(), 'day'),
    })).filter(
        item =>
            !item.dtFinal ||
            dayjs
                .utc(item.dtFinal)
                .isAfter(
                    dayjs().subtract(empresa?.diasRescisao ?? 1, 'days'),
                    'day',
                ),
    )

    return (
        <Dialog.Root width="auto">
            <Dialog.Title>Funcionários</Dialog.Title>
            <Dialog.Content dividers>
                <ContentGuide.DataGrid
                    loading={isLoading}
                    columns={columns}
                    rows={rows}
                    ToolbarProps={{ hideToolbar: true }}
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton>
                    Fechar
                </Dialog.Actions.SecondaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
